<template>
<v-container>
    <ul>
        <li  v-for="group in groupList" :key="group._id">
            <h1> {{ group }} </h1>
        </li>
    </ul>
    
</v-container>
</template>
<script>
export default {
    mounted() {
        this.$store.dispatch('groupHead/fetchList')
    },
    computed: {
        groupList() {
            return this.$store.state.groupHead.groupList
        }
    }

}
</script>

<style>

</style>
